import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	ViewChild,
	ElementRef,
	HostListener,
	Output,
	EventEmitter,
} from '@angular/core';
import { Subject } from 'rxjs';
import { UserSearchParams, User, UserService } from '@app/models/user';
import { ErrorService } from '@app/services/error.service';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-atom-respondant-inline-list',
	templateUrl: './atom-respondant-inline-list.component.html',
	styleUrls: ['./atom-respondant-inline-list.component.less'],
})
export class AtomRespondantInlineListComponent implements OnInit, OnDestroy {
	/** @type {Subject<void>} Observables unsubscriber */
	protected unsubscribe: Subject<void> = new Subject<void>();

	@Input() searchParams: UserSearchParams;
	@Input() seeFullList: boolean = true;
	@Input() customLink: string | null;

	@Output() respondantsNumber = new EventEmitter<number>();

	loading = true;
	items: User[];

	/** Variable used for caroussel */
	@ViewChild('cardsRespondantContainer') cardsContainer: ElementRef;
	position: number;
	posScroll: number;
	btnScrollNext: boolean;
	widthContainer: number;
	nbColumn: number;
	maxPag: number;
	currentPag: number;

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.refreshSize();
	}

	constructor(
		private userService: UserService,
		private errorService: ErrorService
	) {
		this.position = 0;
		this.posScroll = 0;
		this.btnScrollNext = true;
		this.nbColumn = 0;
		this.maxPag = 0;
		this.currentPag = 0;
	}

	ngOnInit() {
		this.refresh();

		this.searchParams.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
			this.refresh();
		});
	}

	ngOnDestroy() {
		this.unsubscribe.next();
	}

	async refresh() {
		this.loading = true;
		if (this.searchParams) {
			this.items = await this.userService
				.list(this.searchParams.toObject())
				.then((result) => result.items)
				.catch((err) => {
					this.errorService.handle(err);
					return [];
				});
		}
		this.loading = false;
		this.emitNumberRespondants(this.items.length);

		this.refreshSize();
	}

	refreshSize(): void {
		if (!this.cardsContainer) return;

		this.widthContainer = this.items.length * 170;
		this.nbColumn =
			Math.trunc(this.cardsContainer.nativeElement.offsetWidth / 170) - 2;
		const pag = (this.widthContainer - 2 * 170) / (this.nbColumn * 170);
		if (Number.isInteger(pag)) {
			this.maxPag =
				(this.widthContainer - 2 * 170) / (this.nbColumn * 170) - 1;
		} else {
			this.maxPag = Math.trunc(
				(this.widthContainer - 2 * 170) / (this.nbColumn * 170)
			);
		}

		this.position = 0;
		this.currentPag = 0;
		this.cardsContainer.nativeElement.scrollLeft = 0;
	}

	next(): void {
		this.position = this.position - this.nbColumn * 170;
		this.currentPag = this.currentPag + 1;
	}

	prev(): void {
		this.position = this.position + this.nbColumn * 170;
		this.currentPag = this.currentPag - 1;
	}

	scroll(event: Event): void {
		let element = event.target as HTMLDivElement;
		this.posScroll = element.scrollLeft;
		if (element.scrollWidth - element.offsetWidth == this.posScroll) {
			this.btnScrollNext = false;
		} else {
			this.btnScrollNext = true;
		}
	}

	emitNumberRespondants(value: number) {
		this.respondantsNumber.emit(value);
	}
}
